import { gql } from '@apollo/client';

export const UPSERT_COHORT = gql`
  mutation UpsertCohort($input: UpsertCohortInput!) {
    cohort: upsertCohort(input: $input) {
      id
    }
  }
`;
